import React from 'react';
import Hero from '../components/ui/Hero';

const TermsOfService: React.FC = () => (
  <>
    <Hero
      title="ОБЩИ УСЛОВИЯ"
      buttonText="Продължи надолу"
      fontSize={42}
      onButtonClick={() => window.scrollTo({ top: 768, behavior: 'smooth' })}
    />
    <section className="container my-5 text-start">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="card-title mb-4 text-center">Общи условия</h2>
          <p>
            Настоящите Общи условия уреждат взаимоотношенията между „ХРИСТИЯНА
            ИВАНОВА“ ЕООД (наричано по-долу „Доставчик“) и потребителите на
            уебсайта{' '}
            <a
              href="https://hristiyana-ivanova.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://hristiyana-ivanova.com/
            </a>{' '}
            (наричани по-долу „Клиенти“). С използването на сайта всеки
            потребител потвърждава, че е запознат и приема настоящите Общи
            условия.
          </p>
          <p>
            Доставчикът има право да променя Общите условия по всяко време чрез
            актуализирането им на сайта. Промените влизат в сила незабавно и са
            задължителни за всички потребители.
          </p>
          <hr />
          <h5 className="mt-4">1. Идентификационни данни на Доставчика</h5>
          <ul>
            <li>Наименование: „ХРИСТИЯНА ИВАНОВА“ ЕООД</li>
            <li>ЕИК: 208327931</li>
            <li>
              Адрес: България, гр. Горна Оряховица, ул. „Цар Освободител“ №57
            </li>
            <li>
              Имейл:{' '}
              <a href="mailto:hristiyanaivanova9222@gmail.com">
                hristiyanaivanova9222@gmail.com
              </a>
            </li>
          </ul>
          <hr />
          <h5 className="mt-4">2. Услуги и продукти</h5>
          <p>
            Доставчикът предлага онлайн услуги, включително таро консултации и
            духовни насоки. Тези услуги не представляват медицински,
            психологически или правни съвети.
          </p>
          <hr />
          <h5 className="mt-4">3. Сключване на договор</h5>
          <p>
            Подаването на поръчка за услуга чрез уебсайта представлява
            обвързваща заявка от страна на Клиента. Договорът се счита за
            сключен след потвърждение от Доставчика по имейл.
          </p>
          <hr />
          <h5 className="mt-4">4. Отказ от услуга и възстановяване на суми</h5>
          <p>
            Клиентът има право да се откаже от заявена услуга до 12 часа след
            извършване на поръчката, при условие че услугата все още не е
            предоставена.
          </p>
          <p>
            При отказ след изтичане на този срок или след предоставяне на
            услугата, заплатената сума не подлежи на възстановяване.
          </p>
          <hr />
          <h5 className="mt-4">5. Уточнения относно въпроси и комуникация</h5>
          <ul>
            <li>
              Клиентът следва да предостави конкретни и ясно формулирани въпроси
              при подаване на заявката за таро консултация.
            </li>
            <li>
              Поръчки, изпратени без въпроси, няма да бъдат обработвани до
              получаване на необходимата информация.
            </li>
            <li>
              Доставчикът не се задължава да допълва, преформулира или измисля
              въпроси от името на Клиента, тъй като точността на консултацията
              зависи от ясно поставеното запитване и личната отговорност на
              Клиента.
            </li>
            <li>
              Доставчикът цени взаимното уважение и добрата комуникация. При
              проява на груб тон, обидно отношение, тормоз или неуместен натиск
              от страна на клиента, Доставчикът си запазва правото едностранно
              да откаже извършването на консултацията. В тези случаи договорът
              се прекратява, а заплатената от клиента сума се възстановява в
              пълен размер в срок до 10 работни дни. С поръчката си клиентът се
              съгласява, че грубото поведение е основание за отказ от услуга.
            </li>
            <li>
              Условия за провеждане на видео консултации
              <ul>
                <li>
                  30-минутна Таро консултация: Разглежда се едно житейско
                  направление с възможност за задаване на до 10 предварително
                  подготвени, конкретни и различни въпроса. Броят на разгледаните
                  въпроси зависи от тяхната сложност и времето за отговор.
                </li>
                <li>
                  90-минутна Таро терапия: Първите 45 минути са посветени на
                  задълбочен личностен анализ, а останалите 45 минути – на
                  въпроси от различни житейски направления.
                </li>
                <li>
                  Записване на консултациите: Аудио- или видеозаписването на
                  консултацията, включително чрез външни устройства, без
                  предварителното изрично съгласие на изпълнителя е забранено. При
                  установяване на подобно нарушение консултацията се прекратява
                  незабавно, независимо от оставащото време.
                </li>
              </ul>
            </li>
          </ul>
          <hr />
          <h5 className="mt-4">6. Начини на плащане</h5>
          <ul>
            <li>банков превод</li>
          </ul>
          <hr />
          <h5 className="mt-4">7. Отговорност</h5>
          <p>
            Доставчикът не носи отговорност за каквито и да е решения,
            предприети от Клиента въз основа на получените консултации.
          </p>
          <hr />
          <h5 className="mt-4">8. Защита на личните данни</h5>
          <p>
            Личните данни на Клиентите се обработват съгласно Политиката за
            поверителност, публикувана на уебсайта на „ХРИСТИЯНА ИВАНОВА“ ЕООД.
          </p>
          <hr />
          <h5 className="mt-4">9. Спорове и приложимо право</h5>
          <p>
            Всички спорове, възникнали във връзка с настоящите Общи условия, се
            уреждат по взаимно съгласие, а при липса на такова – съгласно
            действащото законодателство на Република България.
          </p>
          <hr />
          <p className="text-muted small">
            Настоящите Общи условия са в сила от датата на тяхното публикуване
            на уебсайта{' '}
            <a
              href="https://hristiyana-ivanova.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://hristiyana-ivanova.com/
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  </>
);

export default TermsOfService;
